
export class TreeItem {
    constructor(
        id: string = undefined,
        title: string = undefined,
        dataItem: any = undefined,
        type: any = undefined) {
        this.id = id;
        this.title = title;
        this.type = type;
        this.dataItem = dataItem;
    }

    id: string;
    title: string;
    type: string;
    dataItem: any;
    children: any = {};
    expanded: boolean = false;

    addNode(node: TreeItem) {
        if (!this.children[node.type]) this.children[node.type] = [];
        this.children[node.type].push(node);
    }

    getNode(id: string): TreeItem {
        if (this.id === id) return this;
        Object.keys(this.children).find(key => {
            let node = this.children[key].find(item => item.getNode(id))
            // console.log(node);
            return node;
        })
        // for (var child in this.children) {
        //     let childNode = this.children[child].getNode(id);
        //     if (childNode) return childNode;
        // }
    }

    getChildren(): any[] {
        return Object.keys(this.children).map(key => {
            return this.children[key].map(item => item.getView());
        })[0];
    }


    getView() {
        return {
            id: this.id,
            title: this.title,
            expanded: this.expanded,
            children: this.getChildren()
        }
    }
}
